/* eslint-disable */
import { User } from '@Types/index';
import { userInfoActions } from '@Store/slices/userInfoSlice';
import { useGetUserInfoMutation } from '@Store/api/userApiSlice';
import { ApprovalsListResponse } from '@Types/api/approvalsList';

import { useAppDispatch } from '.';

interface ReturnValue {
  collectUserInformation: (taskLists: ApprovalsListResponse[]) => void;
}

const useUserCollector = (): ReturnValue => {
  const [getUserByNumber] = useGetUserInfoMutation();
  const dispatch = useAppDispatch();

  const collectUserInformation = async (
    taskLists: ApprovalsListResponse[]
  ): Promise<void> => {
    const responseCache = new Map<string, User>();

    for (const task of taskLists) {
      if (!task.variables?.employeeNo) {
        continue;
      }

      const empNumber = task.variables?.employeeNo?.value;

      // Skipping fetch. Already in cache.
      if (responseCache.has(empNumber)) {
        continue;
      }

      try {
        const response = await getUserByNumber({
          empNo: empNumber,
        });

        const data = (await response) as { data: User };
        responseCache.set(empNumber, data.data);
      } catch (error) {
        console.error(`Error fetching`, error);
      }
    }

    dispatch(userInfoActions.addUserCollection(responseCache));
  };

  return {
    collectUserInformation,
  };
};

export default useUserCollector;
